import { parseAsString, useQueryStates } from "next-usequerystate"

import type { Nullish } from "~/@types/generics"
import { CONFORT_PARAM, OPTIONS_PARAM, SIZE_PARAM } from "~/components/ui/Product/ProductHeader/_data/constants"

export const OPTIONS_SEPRATOR = ","

type UseVariantSwitchParams = {
  defaultSize?: Nullish<string>
  defaultConfort?: Nullish<string>
  defaultOptions?: Nullish<string[]>
}

export function useVariantSwitch({ defaultSize, defaultConfort, defaultOptions }: UseVariantSwitchParams) {
  const [data, setData] = useQueryStates(
    {
      [SIZE_PARAM]: { ...parseAsString, defaultValue: defaultSize },
      [CONFORT_PARAM]: { ...parseAsString, defaultValue: defaultConfort },
      [OPTIONS_PARAM]: {
        parse: (value) => value?.split(OPTIONS_SEPRATOR) ?? [],
        serialize: (value) => value?.join(OPTIONS_SEPRATOR) ?? null,
        defaultValue: defaultOptions ?? [],
      },
    },
    {
      history: "replace",
      shallow: true,
      scroll: false,
    }
  )

  function setCurrentOptionsWithSearchParams(newOptions: Nullish<string[]>) {
    setData({
      [OPTIONS_PARAM]: newOptions,
    })
  }

  function setCurrentProductMultipleOptions(newSize: string, newConfort?: string) {
    setData({
      [SIZE_PARAM]: newSize,
      ...(newConfort && {
        [CONFORT_PARAM]: newConfort,
      }),
    })
  }

  return {
    currentOptions: data[OPTIONS_PARAM],
    setCurrentOptions: setCurrentOptionsWithSearchParams,
    setCurrentProductMultipleOptions,
    currentProductMultipleOptions: {
      [SIZE_PARAM]: data[SIZE_PARAM],
      ...(data[CONFORT_PARAM] && { [CONFORT_PARAM]: data[CONFORT_PARAM] }),
    },
  } as const
}
